import React from 'react';

function SkillItem({ skill, onEdit, onDelete }) {
  const ratingLabels = {
    0: 'Beginner',
    1: 'Intermediate',
    2: 'Advanced',
    3: 'Expert',
  };

  const skillTypeLabels = {
    0: 'Job related skills',
    1: 'Hard skills',
    2: 'Soft skills',
  };

  return (
    <li key={skill.id} className="experience-item">
      <div className="experience-content">
        <div>
          <strong>{skill.skillName}</strong> ({ratingLabels[skill.skillRating] || 'No rating'})
          <br />
          <em className="text-muted small">{skillTypeLabels[skill.skillType]}</em>
          <br />
        </div>
        <div className="experience-actions">
          <i className="fa fa-pencil edit-icon" title="Edit" onClick={() => onEdit(skill)}></i>
          <i className="fa fa-trash delete-icon" title="Delete" onClick={() => onDelete(skill)}></i>
        </div>
      </div>
    </li>
  );
}

export default SkillItem;
